import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReportRoutingModule } from "./report-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule, NgbHighlight, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
// import { DataTablesModule } from 'angular-datatables';
import { AgGridModule } from 'ag-grid-angular';

import { ReportComponent } from "src/app/components/reports/report.component";
import { ExcelService } from "src/app/services/excel.service";
import { VendorService } from "src/app/services/vendor.service";
import { CustomerService } from "src/app/services/customer.service";
import { NetworkService } from "src/app/services/network.service";
import { ProductService } from "src/app/services/products.service";
import { ListCustomReportComponent } from "src/app/components/reports/custom-report/list/list.component";
import { AddCustomReportComponent } from "src/app/components/reports/custom-report/add/add.component";
import { EditCustomReportComponent } from "src/app/components/reports/custom-report/edit/edit.component";
import { ShareComponent } from "src/app/components/reports/custom-report/share/share.component";
import { ReportService } from "src/app/services/report/report.service";
import { CompanyService } from "src/app/services/company.service";
import { ListReportNewComponent } from "src/app/components/reports/report-new/list/list.component";
import { ViewReportNewComponent } from "src/app/components/reports/report-new/view/view.component";

@NgModule({
    declarations: [
        ReportComponent,
        AddCustomReportComponent,
        EditCustomReportComponent,
        ListCustomReportComponent,
        ShareComponent,
        ListReportNewComponent,
        ViewReportNewComponent
    ],
    imports: [
        CommonModule,
        ReportRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NgbHighlight,
        NgbNavModule,
        NgbDropdownModule,
        NgbTypeaheadModule,
        NgbPaginationModule,
        NgSelectModule,
        AgGridModule,
        SharedModule,
        NgbAccordionModule
    ],
    exports: [
        ReportComponent,
        AddCustomReportComponent,
        EditCustomReportComponent,
        ListCustomReportComponent,
        ShareComponent,
        ListReportNewComponent,
        ViewReportNewComponent
    ],
    providers: [ReportService, ExcelService, VendorService, CustomerService, NetworkService, ProductService, CompanyService]
})

export class ReportModule { }